import clsx from "clsx"
import { ReactNode } from "react"
import { npPagePtClassName } from "src/components/np-design/components/constants"

export type MinimalLayoutProps = {
  children: ReactNode
}

export const MinimalLayout = ({ children }: MinimalLayoutProps) => {
  return <div className={clsx(npPagePtClassName, "min-h-[50vh]")}>{children}</div>
}
